import React, { Component } from 'react';
import Dotdotdot from 'react-dotdotdot';
import { Button, Row, Col } from 'react-bootstrap';
import './CoursesTab.css';
import config, { hubAccessLevels } from '../../constant/config';
import { Link } from 'react-router-dom';
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import { IconContext } from "react-icons";
import { FaCaretDown, FaCaretRight } from 'react-icons/fa';
import infoIcon from '../../resources/img/info-icon.png';

export class CoursesTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCourses: true,
      showGroupInfo: false,
      showGroupDetails: false,
      showDrafts: true,
      showPublished: true
    };
  }

  renderGroupDetailsTable() {
    const userDetails = this.state.selectedGroup.users;
    return userDetails.map((user) => (
      <tr key={user.userId}>
        <td style={{ textAlign: 'center' }}>
          <div
            className="avatar-image"
            style={{
              backgroundImage: `url(${config.spacesURL}/${user.avatarId})`
            }}
          />
        </td>
        <td style={{ textAlign: 'center' }}>{user.name}</td>
        <td style={{ textAlign: 'center' }}>{user.progress}</td>
      </tr>
    ));
  }

  renderGroupsTable() {
    const selectedCourseGroups = this.state.selectedCourse.groupsDetails;
    return selectedCourseGroups.map((eachGroup) => (
      <tr key={eachGroup.groupId}>
        <td style={{ textAlign: 'center' }}>
          <div
            className="group-name"
            onClick={() => {
              this.setState({
                showGroupDetails: true,
                selectedGroup: eachGroup,
                showGroupInfo: false
              });
            }}
          >
            {eachGroup.groupName}
          </div>
        </td>
        <td style={{ textAlign: 'center' }}>{eachGroup.noOfUsers}</td>
        <td style={{ textAlign: 'center' }}>{eachGroup.completions}</td>
        <td style={{ textAlign: 'center' }}>{eachGroup.deadLine}</td>
      </tr>
    ));
  }

  async downloadReport(courseId, courseName) {
    try {
      const res = await fetch(
        `${config.apiURL}/course/report/analytics/${courseId}`,
        {
          credentials: 'include',
          method: 'GET',
          headers: { 'content-type': 'application/json' }
        }
      );

      if (!res.ok) {
        const errorText = await res.text();
        console.error('Server returned error:', errorText);
        alert(`Failed to load report (HTTP ${res.status})`);
        return;
      }
      const reportData = await res.json();

      if (!reportData || reportData.length === 0) {
        alert('No data available for this report.');
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(reportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

      XLSX.writeFile(workbook, `Course_${courseName}_Report.xlsx`);
    } catch (error) {
      console.error('Error downloading report:', error);
      alert('Failed to download report. ');
    }
  }
  renderCourses(tile, index) {
    const data = tile.isDraft
      ? { hub: this.props.hub, course: tile, fromCourseTab: true, hubId: this.props.hub.id}
      : { hub: this.props.hub, course: tile };
    const link = tile.isDraft
      ? `/edit/course/${tile.courseId}`
      : `/course/${tile.courseId}`;
    return (
      <div className="tile-container">
        <Link
          to={{ pathname: link, state: data }}
          className="tile-image-container"
          style={{ backgroundImage: `url(${config.spacesURL}/${tile.logoId})` }}
        />
        <div className="module-name-container">
          <Link
            to={{ pathname: link, state: data }}
            className="plan-name"
            style={{ color: '#646464' }}
            title={tile.isDraft ? 'Draft: ' + tile.courseName : tile.courseName}
          >
            {tile.isDraft ? 'Draft: ' + tile.courseName : tile.courseName}
          </Link>
        </div>
        <div className="hub-name-container">
          <div
            className="tile-hub-image"
            style={{
              backgroundImage: `url(${config.spacesURL}/${this.props.hub.logoId}.thumbnail)`
            }}
          />
          <h4 className="hub-name" style={{ color: '#A5A3A3' }}>
            <Link to={`/${this.props.hub.pathName}`}>
              {this.props.hub.name}
            </Link>
          </h4>
        </div>
        {this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN &&
          !tile.isDraft && (
            <div className="buttons-container">
              <Button
                onClick={() => {
                  this.setState({
                    selectedCourse: tile,
                    showGroupInfo: true,
                    showCourses: false
                  });
                }}
              >
                Group Info
              </Button>
              <Button
                onClick={() => {
                  this.downloadReport(tile.courseId, tile.courseName);
                }}
              >
                <FontAwesomeIcon
                  icon={faDownload}
                  style={{ marginRight: '8px' }}
                />
                Course Report
              </Button>
            </div>
          )}
      </div>
    );
  }
  // need to check the conditions
  render() {
    return (
      <div>
        {this.props.publishedCourses.length <= 0 &&
          this.props.hub.userAccessLevel < hubAccessLevels.HUB_ADMIN && (
            <div
              style={{
                padding: '20px',
                fontSize: '18px',
                display: 'flex',
                justifyContent: 'center',
                fontWeight: 'bold'
              }}
            >
              You haven’t been assigned any courses yet.
            </div>
          )}
        {(this.props.hub.userAccessLevel >= hubAccessLevels.HUB_ADMIN || this.props.publishedCourses.length > 0) && (
          <div className="main-container-courses">
            {this.state.showCourses && (
              <div className="list-courses-container">
                <div className="home-tab-container">
                  <div className="main-heading">Courses</div>
                  {this.props.hub.userAccessLevel >=
                    hubAccessLevels.HUB_ADMIN && (
                    <Row className="section-container">
                      <div className="main-heading" style={{ display: 'flex' }}>
                        Drafts
                        <div
                          className="info-container"
                          style={{ marginTop: '5px' }}
                        >
                          <img
                            className="info-icon"
                            src={infoIcon}
                            alt="help icon"
                            style={{ height: '18px', width: '18px' }}
                          />
                          <span
                            className="hover-text"
                            style={{ top: '-5px', left: '0px' }}
                          >
                            The following courses are still in progress and are yet to be published.
                          </span>
                        </div>
                        <Button
                          onClick={() => {
                            this.setState({
                              showDrafts: !this.state.showDrafts
                            });
                          }}
                        >
                          <IconContext.Provider
                            value={{
                              style: {
                                color: '#14B4C8',
                                size: '150px'
                              }
                            }}
                          >
                            {this.state.showDrafts ? (
                              <FaCaretDown />
                            ) : (
                              <FaCaretRight />
                            )}
                          </IconContext.Provider>
                        </Button>
                      </div>
                      {this.state.showDrafts && (
                        <Col className="draft-content-container">
                          <div className="tiles-container">
                            {this.props.draftCourses.map((tile, index) =>
                              this.renderCourses(tile, index)
                            )}
                          </div>
                        </Col>
                      )}
                      {this.state.showDrafts && this.props.draftCourses.length === 0 && (
                        <Col className="draft-content-container">
                          <div className="tiles-container">
                            <div className="no-drafts-text">No draft courses created.</div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  )}
                  {
                    <Row className="section-container">
                      {this.props.hub.userAccessLevel >=
                        hubAccessLevels.HUB_ADMIN && (
                        <div
                          className="main-heading"
                          style={{ display: 'flex' }}
                        >
                          Published
                          <div
                            className="info-container"
                            style={{ marginTop: '5px' }}
                          >
                            <img
                              className="info-icon"
                              src={infoIcon}
                              alt="help icon"
                              style={{ height: '18px', width: '18px' }}
                            />
                            <span
                              className="hover-text"
                              style={{ top: '-5px', left: '0px' }}
                            >
                              The following courses are available to assign to groups.
                            </span>
                          </div>
                          <Button
                            onClick={() => {
                              this.setState({
                                showPublished: !this.state.showPublished
                              });
                            }}
                          >
                            <IconContext.Provider
                              value={{
                                style: {
                                  color: '#14B4C8',
                                  size: '150px'
                                }
                              }}
                            >
                              {this.state.showPublished ? (
                                <FaCaretDown />
                              ) : (
                                <FaCaretRight />
                              )}
                            </IconContext.Provider>
                          </Button>
                        </div>
                      )}
                      {this.state.showPublished && (
                        <Col className="content-container">
                          <div className="tiles-container">
                            {this.props.publishedCourses.map((tile, index) =>
                              this.renderCourses(tile, index)
                            )}
                          </div>
                        </Col>
                      )}
                       {this.state.showPublished && this.props.publishedCourses.length === 0 && (
                        <Col className="draft-content-container">
                          <div className="tiles-container">
                            <div className="no-drafts-text">No published courses created.</div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  }
                </div>
              </div>
            )}
            {this.state.showGroupInfo && (
              <div className="group-info-container">
                <div className="sub-header-container">
                  <div className="main-heading">
                    {this.state.selectedCourse.courseName}
                  </div>
                  <div className="header-back-button-container">
                    {' '}
                    <Button
                      className="back-button"
                      onClick={() => {
                        this.setState({
                          showGroupInfo: false,
                          showCourses: true
                        });
                      }}
                    >
                      Back
                    </Button>
                  </div>
                </div>
                <div className="list-courses-table-container">
                  <table className="courses-table">
                    <thead>
                      <tr>
                        <th>Group</th>
                        <th>Number of Users</th>
                        <th>Completions</th>
                        <th>Deadline</th>
                      </tr>
                    </thead>
                    <tbody>{this.renderGroupsTable()}</tbody>
                  </table>
                </div>
              </div>
            )}
            {this.state.showGroupDetails && (
              <div className="group-details-container">
                <div className="sub-header-container">
                  <div className="main-heading" style={{ marginLeft: ' 4rem' }}>
                    {this.state.selectedGroup.groupName}
                  </div>
                  <div className="header-back-button-container">
                    {' '}
                    <Button
                      className="back-button"
                      onClick={() => {
                        this.setState({
                          showGroupInfo: true,
                          showGroupDetails: false
                        });
                      }}
                    >
                      Back
                    </Button>
                  </div>
                </div>
                <div className="list-courses-table-container">
                  <table className="courses-table">
                    <thead>
                      <tr>
                        <th>Avatar</th>
                        <th>Name</th>
                        <th>Progress</th>
                      </tr>
                    </thead>
                    <tbody>{this.renderGroupDetailsTable()}</tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
export default CoursesTab;